import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-queren",
  "use": "icon-queren-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-queren\"><path d=\"M1024 512c0 283.733-228.267 512-512 512S0 795.733 0 512 228.267 0 512 0s512 228.267 512 512zM674.133 356.267L445.867 584.533 358.4 497.067 311.467 544l87.466 87.467 46.934 46.933 275.2-275.2-46.934-46.933z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol